/**
 * Copyright © Veeam Software Group GmbH.
 */

export const isEmpty = (value: string | number | boolean | Object | []): boolean => value === null || value === undefined;
